import React from 'react';
import Select from 'react-select';
import { useState, useEffect } from "react";
import { useHistory, useParams } from 'react-router-dom';
import { ReactComponent as AccLoansIcon }  from '../../../../myfin_v2/assets/icons/AccLoans.svg'

import CompanyEditSideMenu from "../CompanyEditSideMenu"
import HeaderWhenSecondSideBarActive from "../../../elements/HeaderWhenSecondSideBarActive"

import AcntPolcyCss from "../../../css/accountingPolicy.module.css"
import commoncss from "../../../css/common.module.css";
import Breadcrumb from "../../../components/Breadcrumb";


const AccountingPolicy = () => {
    const { companyId } = useParams();
    const [companyID, setCompanyID] = useState(companyId);  // company ID
    const [companyName, setcompanyName] = useState('');  // company name

    const breadcrumbItems = [
        {
            label: "My companies",
            link: `/myfinV2/my-companies`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: companyName,
            link: `/myfinV2/company-details/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "Accounting policy",
            link: `/myfinV2/accounting-policy/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
    ];
 
    return (
        <div className={`${AcntPolcyCss.subContainer}`}>
            <CompanyEditSideMenu 
                activeTab={'Accounting Policies'}
                companyID={companyID}
                companyDataCheck={true}
                setcompanyName={setcompanyName}
            />

            <div className={AcntPolcyCss.subContainer__}>
                {/* <HeaderWhenSecondSideBarActive
                    title="Accounting Policies"
                    secondaryBtnText="Cancel"
                    primaryBtnText="Save"
                /> */}
                <Breadcrumb
                    addCls="bgTransprent"
                    items={breadcrumbItems}
                    headerActions={<></>}
                    p0={true}
                />
                <MainContainer 
                    companyId={companyId}
                />
            </div>
            
        </div>
    );
};

export default AccountingPolicy;


const MainContainer = ({ 
    companyId,
 }) => {
    const routerHistory = useHistory();
    const handleClick = (Link) => {
        routerHistory.push(Link);
    };
    return(
        <div className={AcntPolcyCss.subMainContainer}>
            <div className={AcntPolcyCss.container}>
                <div className={AcntPolcyCss.cardCateContainer} onClick={() => {handleClick(`/myfinV2/loan-policy/${companyId}`)}}>
                    <div>
                        <AccLoansIcon className={AcntPolcyCss.leftCardIcon}/>
                    </div>
                    <div className={AcntPolcyCss.rightCardContainer}>
                        <div className={AcntPolcyCss.cardTitleTxt}>Loans</div>
                        <div className={AcntPolcyCss.cardTxt}> EIR <span className={AcntPolcyCss.txtSep}>|</span> IRAC <span className={AcntPolcyCss.txtSep}>|</span> ECL </div>
                    </div>
                </div>
                <div className={AcntPolcyCss.cardCateContainer} onClick={() => {handleClick(`/myfinV2/receivables-policy/${companyId}`)}}>
                    <div>
                        <AccLoansIcon className={AcntPolcyCss.leftCardIcon}/>
                    </div>
                    <div className={AcntPolcyCss.rightCardContainer}>
                        <div className={AcntPolcyCss.cardTitleTxt}>Receivables</div>
                        <div className={AcntPolcyCss.cardTxt}> ECL </div>
                    </div>
                </div>
            </div>
        </div>
    )
}